export const formatUsersExcelData = (users) => {
  return users.map((u) => ({
    ID: String(u.id),
    "AC/NO.": u.accountNumber,
    "Pending Balance": `${String(u.pendingBalance)}`,
    Name: u.fullName,
    "IFSC CODE": u.ifsc,
    "Bank Name": u.bankName?.name,
    "Current Salary": String(u.salary),
    "Phone Number": u.mobileNumber,
    Email: u.email,
    "Date of Birth": u.dob,
  }));
};
